import React, { useEffect, useRef } from 'react'
import URL from './URL';
import Profile from './Profile';
import * as QRCode from 'easyqrcodejs';

import { useDispatch } from 'react-redux';
import { alertActions } from '../../../_actions/alert.actions';
import { UtilityStepHeader } from '@axshealth/design-library'
import { Card, Row, Col, Button, Alert } from 'react-bootstrap'

const CURRENT_STEP = 'PREVIEW';

const stepColor = {
  icon: {
    current: '#17A2B8',
    complete: '#4CDC6C',
    incomplete: '#D8D8D8',
  },
  text: {
    current: '',
    complete: '',
    incomplete: '#6F6F6F',
  }
};

export default function Preview({
  bio,
  step,
  steps,
  errors,
  domain,
  client,
  licensed,
  stepBack,
  uploading,
  stepForward,
  profileImage,
  handleProfile,
  publishing
}) {

  const dispatch = useDispatch()
  const qrcodeDOM = useRef(null);

  const generateQR = () => {
    const options = {
      text: `https://${domain}.${process.env.REACT_APP_DOMAIN}`,
      logo: profileImage,
      drawer: 'svg',
      width: 100,
      height: 100,
      logoWidth: 35,
      logoHeight: 35,
      colorDark: "#000000",
      colorLight: "#ffffff",
      logoBackgroundTransparent: true,
      correctLevel: QRCode.CorrectLevel.H, // L, M, Q, H
    }

    new QRCode(qrcodeDOM.current, options)
  }

  useEffect(() => {
    if (qrcodeDOM.current) {
      generateQR();
    }
  });

  if (step !== CURRENT_STEP) {
    return null
  }

  return <Row>
    <Col className='px-0' >
      <Card>
        <Card.Body>
          <UtilityStepHeader steps={steps} stepColor={stepColor} />

          <Row>
            <Col xs='12' className="mt-3">
              <Alert variant='primary'>
                Preview your landing page before publishing. When ready, click the publish button below.
              </Alert>
            </Col>
          </Row>

          <Row>
            <Col xs='4' className='mb-4 pr-0'>
              <div className='mb-2 font-weight-bold'>Domain</div>
              <URL urlString={`https://${domain}.${process.env.REACT_APP_DOMAIN}`} fontSize='small' />
            </Col>
            <Col className='my-auto'>
              <div ref={qrcodeDOM} className='img-fluid'></div>
            </Col>
          </Row>

          <Row>
            <Col xs='12' className='mb-4 pt-2'>
              <Card >
                <Card.Body>
                  <Profile
                    bio={bio}
                    client={client}
                    licensed={licensed}
                    uploading={uploading}
                    handleProfile={handleProfile}
                    handleError={() => dispatch(alertActions.error('We could not read the file image. Please select a jpg/jpeg or png image.'))}
                  />
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Row className='justify-content-end my-2'>
            <Col xs='2'>
              <Button block disabled={uploading || publishing} variant='outline-primary' onClick={stepBack}>Back</Button>
            </Col>
            <Col xs='3'>
              <Button block disabled={errors || uploading || publishing} variant={errors ? 'secondary' : 'success'} onClick={stepForward}>Publish</Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Col>
  </Row>
}